// Shared profile images for the /kennenlernen ads landing page.
const profileCtx = require.context(
  '../../../../../images/viluu/landing-v2/kennenlernen',
  false,
  /\.jpg$/
);

const PROFILES = {};
profileCtx.keys().forEach((key) => {
  PROFILES[key.replace('./', '').replace('.jpg', '')] = profileCtx(key);
});

export function profileImg(name) {
  return PROFILES[name] || '';
}

export { PROFILES };
